import { render, staticRenderFns } from "./ClaimDetail.vue?vue&type=template&id=6730f056&"
import script from "./ClaimDetail.vue?vue&type=script&lang=js&"
export * from "./ClaimDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClaimDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimDetail.vue"
export default component.exports